module.exports = __webpack_public_path__ + "static/tatiana-54374a16063692c1cee0b475123861c0.png";